// Helpers for the "pick a round, get its dates" flow on the fixture add forms.
// A round stores its window as two datetimes (gameweek_rounds.start_date / end_date), so a
// fixture takes both its prefill and its allowed date/time range from those two values.

import moment from 'moment'

const DATETIME_FORMATS = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', moment.ISO_8601]

// Returns { round, start, end } with moments, or null when the round has no usable window.
export const getRoundWindow = (round) => {
  if (!round) return null
  const start = moment(round.start_date, DATETIME_FORMATS)
  const end = moment(round.end_date, DATETIME_FORMATS)
  if (!start.isValid() || !end.isValid()) return null
  return { round: round.round, start, end }
}

export const findRoundWindow = (roundList, roundId) =>
  getRoundWindow((roundList || []).find((item) => String(item.id) === String(roundId)))

// The date inputs only deal in days, so min/max are the window's first and last day as
// "YYYY-MM-DD" (the native date input's value format).
export const roundMinDate = (range) => (range ? range.start.format('YYYY-MM-DD') : undefined)
export const roundMaxDate = (range) => (range ? range.end.format('YYYY-MM-DD') : undefined)

// A missing time means the user hasn't picked one yet - compare by day so the time field, not
// the date field, is the one that complains once they do.
export const isWithinRoundWindow = (range, date, time) => {
  if (!range || !date) return true
  if (!time) {
    const day = moment(date, 'YYYY-MM-DD')
    return day.isValid() && day.isBetween(range.start, range.end, 'day', '[]')
  }
  const value = moment(`${date} ${time}`, 'YYYY-MM-DD HH:mm')
  return value.isValid() && value.isBetween(range.start, range.end, undefined, '[]')
}

export const roundRangeMessage = (range) =>
  range
    ? `Must be within Round ${range.round} (${range.start.format(
        'DD/MM/YYYY h:mm A',
      )} - ${range.end.format('DD/MM/YYYY h:mm A')})`
    : ''

export const roundOptionLabel = (round) => {
  const range = getRoundWindow(round)
  return range
    ? `Round ${round.round} (${range.start.format('DD/MM/YYYY')} - ${range.end.format(
        'DD/MM/YYYY',
      )})`
    : `Round ${round.round}`
}
